import { useEffect, useState } from 'react';

/** True while the media query matches; follows changes (window resize, rotation). */
export function useMediaQuery(query: string): boolean {
  const get = () => typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(query).matches;
  const [matches, setMatches] = useState(get);
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia(query);
    const on = () => setMatches(mql.matches);
    on();
    mql.addEventListener('change', on);
    return () => mql.removeEventListener('change', on);
  }, [query]);
  return matches;
}

/** Phone-width screens, where the rail is an overlay sheet instead of a column. */
export const NARROW_QUERY = '(max-width: 767px)';

/** Below the lg breakpoint (1024 px) the rail is icons and opens as an overlay, so the content keeps its width. */
export const COMPACT_RAIL_QUERY = '(max-width: 63.99em)';

/** From the sm breakpoint (40em, 640 px) up. */
export const SM_UP_QUERY = '(min-width: 40em)';
